<template>
  <section class="w-full">

    <div v-if="complianceLinks.length === 0">
      <SaveButton text="Add Compliance Link" @click="addField()"></SaveButton>
    </div>
    <div v-else>

      <div class="grid grid-cols-8 gap-3">

        <div class="col-span-6 sm:col-span-3 hidden sm:inline">
          <label for="compliance_name" class="block text-sm font-medium text-gray-700">Button Name</label>
        </div>
        <div class="col-span-6 sm:col-span-3 hidden sm:inline">
          <label for="compliance_link" class="block text-sm font-medium text-gray-700">Url</label>
        </div>
      </div>

      <div
          v-for="(input, index) in complianceLinks"
          :key="`complianceRecord-${index}`"
          class="grid grid-cols-8 gap-3 mt-3"
      >
        <div class="col-span-6 sm:col-span-3">
          <input
              v-model="complianceLinks[index].name"
              :name="`compliance_link[${index}][name]`"
              :id="`compliance_link_${index}_name`"
              type="text"
              class="appearance-none shadow-sm rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-uknar-primary focus:border-uknar-primary focus:z-10 sm:text-sm"
              :placeholder="`Button Name ${index+1}`"
          />

        </div>

        <div class="col-span-6 sm:col-span-3">
          <input
              v-model="complianceLinks[index].url"
              :name="`compliance_link[${index}][url]`"
              :id="`compliance_link_${index}_url`"
              type="text"
              class="appearance-none shadow-sm rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-uknar-primary focus:border-uknar-primary focus:z-10 sm:text-sm"
              :placeholder="`Url ${index+1}`"
          />

        </div>
        <div class="flex col-span-2">
          <PlusCircleIcon
              v-show="complianceLinks.length < 4"
              @click="addField()"
              :class="`text-green-500 w-6 compliance_link_${index}_add_field`"
          >
          </PlusCircleIcon>
          <XCircleIcon
              v-show="complianceLinks.length > 0"
              @click="removeField(index)"
              :class="`text-red-500 w-6 compliance_link_${index}_remove_field`"
          >
          </XCircleIcon>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import {PlusCircleIcon, XCircleIcon} from '@heroicons/vue/solid'
import SaveButton from "../components/form/SaveButton.vue";

export default {
  name: "ManageComplianceUrls",
  data() {
    return {
      complianceLinks: this.links,
    }
  },
  props: {
    links: {
      type: Array,
      default: []
    },
  },
  components: {
    PlusCircleIcon,
    XCircleIcon,
    SaveButton
  },
  methods: {
    addField() {
      this.complianceLinks.push({name: "", url: ""});
    },
    removeField(index) {
      this.complianceLinks.splice(index, 1);
    }
  },
};
</script>
